<template>
    <div class="custom-modal show-custom-modal" @click="closeCustomModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close btn-white" @click="closeCustomModal()"></div>

            <div class="custom-modal-body pt-0">

                <div class="custom-register-container" :class="{ 'slided' : treatment_token }">

                    <div class="custom-step step1" v-if="input_mode === 'camera'">

                        <div class="message-window-container" :class="{ 'show': showQRMessage || showPartPaymentMessage }" @click="closeMessage()">

                            <div class="message-window" @click.stop>

                                <div v-if="showQRMessage">
                                    <img src="/images/card/register-success.png" style="width:80%; margin-left: 10%;" class="mb-4">
                                    <p class="mb-6">
                                        
                                        <span v-if="app_version === 'customer_card' && card.product_area_id === 2">Registrera ditt träningspass genom att scanna tränarens QR-kod.</span>
                                        <span v-else>Registrera din behandling genom att scanna massörens QR-kod.</span>

                                        <span v-if="app_version === 'company_card' && employee_part_payment_type === 'allowance_or_salary'">Välj först hur din andel ska betalas</span>
                                    </p>
                                </div>

                                <div class="mb-6" v-if="showPartPaymentMessage">
                                    <h3>Hur vill du betala din andel?</h3>
                                    <p><i>Du behöver själv hålla reda på om friskvårdsbidraget räcker till.</i></p>

                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-wellness" value="allowance" v-model="part_payment_type">
                                        <label class="form-check-label" for="customer-payment-wellness">Friskvårdsbidrag</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-salary" value="salary" v-model="part_payment_type">
                                        <label class="form-check-label" for="customer-payment-salary">Löneavdrag</label>
                                    </div>
                                </div>

                                <button class="btn btn-primary btn-sm w-100 text-white" v-if="showPartPaymentMessage" @click="closeMessage('cookie')">Spara</button>

                                <button class="btn btn-primary btn-sm w-100 text-white" @click="closeMessage('cookie')" v-else>Okej, stäng</button>

                            </div>

                        </div>

                        <div class="message-window-container" style="z-index: 3990;" :class="{ 'show': showErrorMessage }" @click="closeErrorMessage()">

                            <div class="message-window" style="min-height:0;" @click.stop>

                                <h3>Ett fel uppstod</h3>
                                <p class="mb-6">{{ validation_error }}</p>

                                <button class="btn btn-primary btn-sm w-100 text-white" @click="closeErrorMessage()">Stäng</button>

                            </div>

                        </div>

                        <button class="btn btn-white btn-sm position-absolute text-primary" style="bottom:30px; left:30px; z-index: 3990; border-radius: 50rem;" @click="setInputMode('text')" v-if="!treatment_token">
                            Registrera behandling med kod
                        </button>

                        <div class="qr-scanner-container">
                            <qr-scanner
                            @decode="onCameraDecode"
                            ref="scanner"
                            >
                            </qr-scanner>
                        </div>

                    </div>


                    <div class="custom-step step1 pt-8" v-if="input_mode === 'text'">

                        <div class="container-fluid">

                            <h1>Registrera behandling med kod</h1>

                            <p class="mb-4">Ange massörens kod för att registrera behandlingen.</p>

                            <form action="#" @submit.prevent="makePunch">

                                <input-text
                                    type="text"
                                    name="signature_key"
                                    placeholder="Massörens kod"
                                    v-model="signature_key"
                                    :inputClass="punchInputClasses"
                                    customErrorMessage="Vänligen ange en korrekt massörskod."
                                    autocorrect="off"
                                    autocomplete="off"
                                    v-if="from_camera === false"
                                />
                                <div class="invalid-feedback" :class="{show: validation_error }" v-if="poster.unhandled_error">
                                    {{ validation_error }}
                                </div>

                                <div class="pb-1 pt-1" v-if="app_version === 'company_card' && employee_part_payment_type === 'allowance_or_salary'">
                                    <h4 class="mt-6">Hur vill du betala din andel?</h4>
                                    <p><i>Du behöver själv hålla reda på om friskvårdsbidraget räcker till.</i></p>

                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-wellness" value="allowance" v-model="part_payment_type">
                                        <label class="form-check-label" for="customer-payment-wellness">Friskvårdsbidrag</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-salary" value="salary" v-model="part_payment_type">
                                        <label class="form-check-label" for="customer-payment-salary">Löneavdrag</label>
                                    </div>
                                </div>

                                <div class="pb-3" v-if="app_version === 'company_card'">
                                    <h4 class="mt-6">Behandlingslängd</h4>
                                    <p>{{ duration_title }}</p>
                                </div>

                                <button class="btn btn-primary w-100 mt-4" :disabled="poster.submitted">Registrera
                                    behandling
                                </button>

                            </form>

                            <div class="pt-2">
                                <a class="color-primary" style="text-decoration: none;" @click="setInputMode('camera')">
                                    Scanna QR-kod  >>
                                </a>
                            </div>

                        </div>

                    </div>


                    <div class="custom-step step2 d-flex align-items-center" :class="{ 'confirmed' : punchConfirmed }">

                        <div class="step2-confirmed">

                            <div class="success-checkmark">
                              <div class="check-icon">
                                <span class="icon-line line-tip"></span>
                                <span class="icon-line line-long"></span>
                                <div class="icon-circle"></div>
                                <div class="icon-fix"></div>
                              </div>
                            </div>

                            <h1>Registrerat!</h1>

                        </div>

                        <div class="container-fluid text-white text-center step2-content">

                            <img :src="clinic.portrait.thumb_url" class="mb-8" style="width:140px; border-radius: 50%; overflow: hidden; border:4px solid white;" v-if="clinic.portrait">

                            <img src="/images/card/illustration-pt.png" class="mb-8" style="width:140px; border-radius: 50%; overflow: hidden; border:4px solid white;" v-else-if="app_version === 'customer_card' && card.product_area_id === 2">

                            <img src="/images/card/illustration-qr-nothumb.png" class="mb-8" style="width:140px; border-radius: 50%; overflow: hidden; border:4px solid white;" v-else>

                            <p v-if="app_version === 'customer_card' && card.product_area_id == 2">Du har varit på personlig träning hos</p>
                            <p v-else>Du har varit på <span v-if="app_version === 'company_card'">{{ duration_title }}</span> massage hos</p>
                            
                            <h1 class="text-white mb-10" v-if="clinic.checkbox_multiple_clinics">{{ clinic.name_clinic }}</h1>
                            <h1 class="text-white mb-10" v-else>{{ clinic.name_person }},<br>{{ clinic.name_clinic }}</h1>

                            <p>Ditt namn<br><b>{{ customer_name }}</b></p>

                            <button class="btn btn-white btn-lg mb-4" :class="{ 'loading' : poster.submitted }" style="width:200px; color:#009ca0; margin-top:80px;" :disabled="poster.submitted" @click="posterPost()">
                                <span>Bekräfta</span>
                            </button><br>
                            <a class="text-white" @click="abort()">Avbryt</a>

                        </div>

                    </div>

                    <div class="spinner" v-if="poster.submitted"></div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

import modaler from '../../../shared/mixins/modaler'
import poster from '../../../shared/mixins/poster'
import jQuery from 'jquery'

import QrScanner from './qr-scanner.vue'

export default {

    mixins: [
        modaler,
        poster
    ],

    components: {
        QrScanner
    },

    props: {
        card: {
            required: true
        },
        employee_part_payment_type: {
            default: 'none'
        },
        employee_part_payment_amount: {
            default: 0
        },
        treatment_duration: {
            default: 0
        }
    },

    data () {
        return {
            input_mode: 'camera', // camera || text
            signature_key: '',
            part_payment_type: this.employee_part_payment_type === 'allowance_or_salary' ? 'allowance' : null,
            treatment_token: null,
            clinic: {},
            customer_name: '',

            validation_error: false,
            durations: ['Information saknas', '25 minuter', '40 minuter', '60 minuter', '50 minuter'],
            is_demo: window.is_demo,

            from_camera: false,

            showQRMessage: false,
            showPartPaymentMessage: false,
            showErrorMessage: false,

            punchConfirmed: false
        }
    },

    mounted () {
        this.showQRMessage = true
        if (Cookies.get('hideQRMessage') == 1) {
            this.showQRMessage = false
        }

        if (this.app_version === 'company_card' && this.employee_part_payment_type === 'allowance_or_salary') {
            this.showPartPaymentMessage = true
        }
    },

    computed: {

        posterUrl () {
            return '/treatments/' + (this.treatment_token ? 'store' : 'validate')
        },

        posterData () {
            return {
                card_id: this.app_version === 'customer_card' ? this.card.id : null,
                signature_key: this.signature_key,
                part_payment_type: this.part_payment_type,
                treatment_token: this.treatment_token
            }
        },

        punchInputClasses () {
            let classes = 'form-border text-center'
            if (this.validation_error) {
                classes += ' is-invalid'
            }
            return classes
        },

        duration_title () {
            return this.durations[this.treatment_duration]
        }

    },

    methods: {

        onCameraDecode (decodedString) {
            console.log('onCameraDecode decodedString')
            console.log(decodedString)

            decodedString = decodedString.replace('hr-pt-', 'pt-')
            decodedString = decodedString.replace('hr-', 'm-')

            this.signature_key = decodedString
            this.from_camera = true

            this.makePunch()
        },

        setInputMode (mode) {
            this.input_mode = mode
            this.from_camera = false
        },

        makePunch () {
            document.activeElement.blur()
            this.posterPost()
        },

        posterSuccess (data) {
            this.validation_error = false

            if (data.treatment_token) {
                this.treatment_token = data.treatment_token
                this.clinic.name_person = data.clinic.name_person
                this.clinic.name_clinic = data.clinic.name_clinic
                this.clinic.portrait = data.clinic.portrait
                this.clinic.checkbox_multiple_clinics = data.clinic.checkbox_multiple_clinics
                this.customer_name = data.customer_name
                return
            }

            this.punchConfirmed = true

            const self = this

            setTimeout(function () {
                self.closeCustomModal()
                let scrollToPosition = 0
                if (this.app_version === 'customer_card') {
                    scrollToPosition = 300
                }
                jQuery('html, body').stop().animate({ scrollTop: scrollToPosition + 'px' }, 250)
            }, 3500)
        },

        posterFail (response) {
            console.log('posterFail response')
            console.log(response)

            if (!this.treatment_token && (response.data.errormess || response.data.message)) {
                this.validation_error = response.data.errormess ?? response.data.message
                this.showErrorMessage = true
            }
        },

        abort () {
            this.treatment_token = null
            this.$refs.scanner.resume()

            setTimeout(function () {
                this.clinic = {}
                this.customer_name = ''
            }, 360)
        },

        closeMessage () {
            Cookies.set('hideQRMessage', 1, { expires: 365 })

            this.showQRMessage = false
            this.showPartPaymentMessage = false
        },

        closeErrorMessage () {
            this.showErrorMessage = false
            this.$refs.scanner.resume()
        }

    }
}
</script>

<style>
.qrcode-stream-camera {
  /*object-fit: none!important;*/
}
</style>
